"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./SinTrendUtils";

export default function SinThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`sin-ods-detail-item kbv-sin-odt-card ${width}`}>
      <div className="sin-odstb-title kbv-sin-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="sin-odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="sin-title-odds">{item.label}</div>
            <div className={`odds kbv-sin-odt-odds ods-100 ods-white ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
